export class MapTransitionLayerComponentFactoryError extends Error {}